var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CompanyContractorCard", {
    attrs: {
      contractor: _vm.contractor,
      ratingTotal: _vm.ratingTotal,
      currentUserId: _vm.currentUserId,
      currentUserRole: _vm.currentUserRole,
      companyId: _vm.companyId,
      nameBlockMinHeight: _vm.nameBlockMinHeightValue,
      skillsBlockMinHeight: _vm.skillsBlockMinHeightValue,
      userUpdatedDate: _vm.userUpdatedDate,
    },
    on: {
      "update:nameBlockMinHeight": function ($event) {
        _vm.nameBlockMinHeightValue = $event
      },
      "update:name-block-min-height": function ($event) {
        _vm.nameBlockMinHeightValue = $event
      },
      "update:skillsBlockMinHeight": function ($event) {
        _vm.skillsBlockMinHeightValue = $event
      },
      "update:skills-block-min-height": function ($event) {
        _vm.skillsBlockMinHeightValue = $event
      },
      cardDataUpdated: function ($event) {
        return _vm.$emit("cardDataUpdated")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "avatarSecondary",
        fn: function () {
          return [
            _c("ToggleFavorite", {
              attrs: {
                currentUserId: _vm.currentUserId,
                contractorUserId: _vm.contractor.user.id,
                favorites: _vm.contractor.user.favorited_by_users,
              },
              on: {
                updated: function ($event) {
                  return _vm.$emit("cardDataUpdated")
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "nameBlock",
        fn: function ({ status, employeePageRouteParams }) {
          return [
            _c("EmployeeCardName", {
              attrs: {
                status: status,
                employeePageRouteParams: employeePageRouteParams,
                contractorId: _vm.contractor.id,
                avatar: _vm.contractor.user.avatar,
                givenName: _vm.contractor.user.given_name,
                familyName: _vm.contractor.user.family_name,
                contractor: _vm.contractor,
                userUpdatedDate: _vm.userUpdatedDate,
              },
              on: {
                tagUpdated: function ($event) {
                  return _vm.$emit("cardDataUpdated")
                },
              },
            }),
          ]
        },
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ContainerSize",
              {
                staticClass: "mb-4",
                attrs: { minHeight: _vm.managersBlockMinHeightValue },
                on: {
                  "update:minHeight": function ($event) {
                    _vm.managersBlockMinHeightValue = $event
                  },
                  "update:min-height": function ($event) {
                    _vm.managersBlockMinHeightValue = $event
                  },
                },
              },
              [
                _c("CardItemChipsContainer", {
                  attrs: {
                    title: "Managers",
                    collection: _vm.contractor.managers,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ collection }) {
                        return [
                          _c("ManagerChips", {
                            attrs: {
                              managers: collection,
                              contractorId: _vm.contractor.id,
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }